import React, { useEffect, useRef, useState } from 'react'
import { Link, useHistory, useLocation, useParams } from 'react-router-dom'
import Api from '../../../../_helpers/Api'
import Pagination from '../../../Pagination'
import Filter from '../../invoices/partials/Filter'
import loader from '../../../../assets/img/loader.svg'
import NoDataFound from '../../../partials/NoDataFound'
import Options from './ReservationOptions'
import FilterReservations from './FilterReservations'
import Success from '../../../modals/messages/Success'
import Error from '../../../modals/messages/Error'
import Question from '../../../modals/messages/Question'
import { trans } from '../../../../_providers/Translation'
import Skeleton from 'react-loading-skeleton'
import checkIcon from '../../../../assets/img/icons/check.png'
import closeIcon from '../../../../assets/img/icons/close.png'
import { Checkbox } from '@mui/material'
import { enqueueSnackbar } from 'notistack'

let timeout

const safeNum = (v) => parseFloat(v) || 0

function Reservations(props) {

    const params = useParams()
    const location = useLocation()
    const history = useHistory()

    // When rendered inside a modal a partner id is passed via props and we must
    // not sync the filters/pagination with the page URL.
    const relatedPartnerId = props.relatedPartnerId || params.id
    const inModal = !!props.relatedPartnerId

    const searchParams = new URLSearchParams(location.search)

    const status = searchParams.get('status') || ''
    const date = searchParams.get('date') || ''
    const deadline = searchParams.get('deadline') || ''
    const search = searchParams.get('search') || ''

    const selectRef = useRef(null)
    const questionModalRef = useRef(null)
    const reportSuccessModalRef = useRef(null)
    const reportFailModalRef = useRef(null)

    const [selected, setSelected] = useState([])

    const [state, setState] = useState({
        loading: true,
        page: 1,
        data: [],
        total: 0,
        pages: 0,
        totals: {},
        filter: {

        },
        setFilter: false,
        update: false,
        sendingReport: false,
    })

    const [loadingPayment, setLoadingPayment] = useState(false)

    useEffect(() => {
        // In modal mode the partner id comes from props, so trigger the initial
        // load once instead of reacting to the page URL. The status is forced to
        // "unpaid" so only unpaid reservations are shown.
        if (inModal) {
            setState(prev => ({
                ...prev,
                filter: {
                    ...prev.filter,
                    status: 'unpaid'
                },
                update: new Date().getTime()
            }))
            return
        }

        setState(prev => ({
            ...prev,
            page: searchParams.get('page') || 1,
            filter: {
                ...prev.filter,
                status: status,
                date: date,
                deadline: deadline,
                search: search
            },
            update: new Date().getTime()
        }))
    }, [location.search])

    // useEffect(() => {
    //     console.log(state.filter);
    // }, [state.filter]);

    useEffect(() => {
        if (state.setFilter) {
            // In modal mode we keep filters/pagination local instead of pushing
            // them onto the underlying page URL.
            if (inModal) {
                setState(prev => ({
                    ...prev,
                    update: new Date().getTime()
                }))
                return
            }

            searchParams.set('page', state.page)

            Object.entries(state.filter).map(filter => {
                // if (filter[1]) {
                searchParams.set(filter[0], filter[1])
                // }
            })

            let url = '?' + searchParams.toString()

            history.push(url)
        }

    }, [state.setFilter])

    useEffect(() => {
        if (state.update) {
            loadData()
        }
    }, [state.update])

    const loadData = () => {

        setState(prev => ({
            ...prev,
            loading: true
        }))

        let url = 'partners/relationships/reservations?related_partner_id=' + relatedPartnerId + '&page=' + state.page

        Object.entries(state.filter).map(filter => {
            url += '&' + filter[0] + '=' + filter[1]
        })

        Api.get(url)
            .then(res => {

                setState(prev => ({
                    ...prev,
                    data: res.data.items,
                    total: res.data.total,
                    pages: res.data.pages,
                    totals: res.data.totals || {},
                }))
            })
            .finally(() => {
                setState(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }

    const refreshData = () => {
        setState(prev => ({
            ...prev,
            update: new Date().getTime()
        }))
    }

    // Row selection helpers
    const toggleRow = (id) => {
        if (isSelected(id)) {
            setSelected(prev => prev.filter(i => Number(i) !== Number(id)))
        } else {
            setSelected(prev => prev.concat(Number(id)))
        }
    }

    const isSelected = id => {
        return selected.indexOf(Number(id)) > -1
    }

    const toggleAll = () => {
        if (isAllSelected()) {
            setSelected([])
        } else {
            setSelected(state.data.map(c => Number(c.id)))
        }
    }

    const isAllSelected = () => {
        let allSelected = true
        state.data.map(c => {
            if (!isSelected(c.id)) {
                allSelected = false
            }
        })
        return allSelected
    }

    // Payment handlers
    const handleMarkAsPaid = (ids = null) => {
        let question = questionModalRef.current
        question.open()
        question.onSuccess(() => {
            markAsPaid(ids)
        })
    }

    const markAsPaid = (ids) => {
        setLoadingPayment(true)

        Api.post('partners/relationships/set-reservation-paid', {
            ids: ids || selected,
            partner_taxes_paid: true
        }).then(() => {
            onSuccess()
        }).finally(() => {
            setLoadingPayment(false)
        })
    }

    const handleMarkAsUnpaid = () => {
        let question = questionModalRef.current
        question.open()
        question.onSuccess(() => {
            markAsUnpaid()
        })
    }

    const markAsUnpaid = () => {
        Api.post('partners/relationships/set-reservation-paid', {
            ids: selected,
            partner_taxes_paid: false
        }).then(() => {
            onSuccess()
        })
    }

    const onSuccess = () => {
        enqueueSnackbar(
            trans('messages.success'),
            {
                variant: "success",
            },
        )

        refreshData()
        setSelected([])

        if (typeof props.refreshData === 'function') {
            props.refreshData()
        }
    }

    // Search
    const handleSearch = (key, val) => {
        clearTimeout(timeout)

        setState(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                [key]: val,
            },
            page: 1,
        }))

        timeout = setTimeout(() => {
            setState(prev => ({
                ...prev,
                setFilter: new Date().getTime()
            }))
        }, 300)
    }

    const handlePage = page => {
        setState(prev => ({ ...prev, page: page.selected + 1, setFilter: Math.random().toString() }))
    }

    const handleShow = id => {
        window.open('/schedule/reservations/edit/' + id, '_blank')
    }

    const handleAction = () => {
        let action = selectRef.current.value

        switch (action) {
            case 'send':
                send(selected)
                break
            case 'paid':
                handleMarkAsPaid()
                break
            case 'notpaid':
                handleMarkAsUnpaid()
                break
        }
        selectRef.current.value = ''
    }

    const handleSendReport = () => {
        if (state.sendingReport) {
            return
        }

        setState(prev => ({
            ...prev,
            sendingReport: true
        }))

        let data = {
            related_partner_id: relatedPartnerId,
        }

        Object.entries(state.filter).map(filter => {
            data[filter[0]] = filter[1]
        })

        Api.post('partners/relationships/send-report', data)
            .then(res => {
                if (res.data.success) {
                    reportSuccessModalRef.current.open()
                } else {
                    reportFailModalRef.current.open()
                }
            })
            .catch(() => {
                reportFailModalRef.current.open()
            })
            .finally(() => {
                setState(prev => ({
                    ...prev,
                    sendingReport: false
                }))
            })
    }

    const renderPriceWithBreakdown = (r, total, labour, parts) => {
        const currency = r.currency ? r.currency.name : ''

        return (
            <span className="tooltip" style={{ whiteSpace: 'nowrap' }}>
                {total.toFixed(2)} {currency}

                <div className="tooltip-body with-arrow">
                    <table>
                        <tr>
                            <td>
                                {trans('selfEmployed.labourPrice')}:
                            </td>
                            <td style={{ width: '100px', textAlign: 'right' }}>
                                <b style={{ whiteSpace: 'nowrap' }}>
                                    {labour.toFixed(2)} {currency}
                                </b>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {trans('selfEmployed.partsPrice')}:
                            </td>
                            <td style={{ width: '100px', textAlign: 'right' }}>
                                <b style={{ whiteSpace: 'nowrap' }}>
                                    {parts.toFixed(2)} {currency}
                                </b>
                            </td>
                        </tr>
                    </table>
                </div>
            </span>
        )
    }

    const send = ids => {
        Api.post('reservations/send-reassign-info', {
            related_partner_id: relatedPartnerId,
            ids: ids,
        }).then(() => {
            enqueueSnackbar(
                trans('headings.reservationSent'),
                {
                    variant: "success",
                },
            )

            if (typeof props.refreshData === 'function') {
                props.refreshData()
            }
        })
    }


    return (
        <>
            <Question
                ref={questionModalRef}
                mainMessage={trans('headings.question15')}
            />

            <Success
                ref={reportSuccessModalRef}
                mainMessage={trans('headings.success14')}
            />

            <Error
                ref={reportFailModalRef}
                mainMessage={trans('headings.error1')}
            />

            <FilterReservations
                filter={state.filter}
                handleSearch={handleSearch}
                hideStatusFilter={inModal}
                hideSendReport={inModal}
                handleSendReport={handleSendReport}
                sendingReport={state.sendingReport}
            />
            <hr />
            {state.loading
                ?
                <Skeleton height={45} count={5} />
                :
                state.data.length === 0
                    ?
                    <NoDataFound />
                    :
                    <>
                        <div className="collapsable-table">
                            <div className="table-scroller">
                                <table className="collapsable active">
                                    <thead>
                                        <tr>
                                            {!inModal ?
                                                <th style={{
                                                    width: '20px'
                                                }}>
                                                    <Checkbox
                                                        value="1"
                                                        checked={isAllSelected()}
                                                        onChange={e => toggleAll()}
                                                    />
                                                </th>
                                                :
                                                <>
                                                </>
                                            }
                                            <th>
                                                ID
                                            </th>
                                            <th>
                                                {trans('tables.number')}
                                            </th>
                                            <th>
                                                {trans('tables.address')}
                                            </th>
                                            <th>
                                                {trans('tables.visitDate')}
                                            </th>
                                            <th>
                                                {trans('tables.visitHour')}
                                            </th>
                                            <th>
                                                {trans('tables.initialStatus')}
                                            </th>
                                            <th>
                                                {trans('tables.finalStatus')}
                                            </th>
                                            <th className="right">
                                                {trans('tables.tax2')}
                                            </th>
                                            <th className="right">
                                                {trans('tables.partsProfitTable')}
                                            </th>
                                            <th className="right" style={{ whiteSpace: 'nowrap' }}>
                                                {trans('tables.partnerToCompany')}
                                            </th>
                                            <th className="right" style={{ whiteSpace: 'nowrap' }}>
                                                {trans('tables.companyToPartner')}
                                            </th>
                                            <th className="right" style={{ whiteSpace: 'nowrap' }}>
                                                {trans('labels.sanctions')}
                                            </th>
                                            <th className="center">
                                                {trans('selfEmployed.balance')}
                                            </th>
                                            <th className="center">
                                                {trans('tables.isPaid')}
                                            </th>
                                            {!inModal ?
                                                <th className="options">
                                                    {trans('tables.options')}
                                                </th>
                                                :
                                                <>
                                                </>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {state.data.map(r =>
                                            <tr
                                                key={'r-' + r.id}
                                                style={{ color: r.color }}
                                            >
                                                {!inModal ?
                                                    <td style={{
                                                        width: '20px'
                                                    }}>
                                                        <Checkbox
                                                            value="1"
                                                            checked={isSelected(r.id)}
                                                            onChange={() => toggleRow(r.id)}
                                                        />
                                                    </td>
                                                    :
                                                    <>
                                                    </>
                                                }
                                                <td onClick={() => handleShow(r.id)}>
                                                    {r.id}
                                                </td>
                                                <td onClick={() => handleShow(r.id)}>
                                                    <Link
                                                        to={`/reservations/edit/${r.id}`}
                                                    // className="btn"
                                                    // style={{ background: r.color, color: r.text_color }}
                                                    >
                                                        {r.reference_code}
                                                    </Link>
                                                </td>
                                                <td onClick={() => handleShow(r.id)}>
                                                    {r.full_address}
                                                </td>
                                                <td onClick={() => handleShow(r.id)}>
                                                    {r.visit_date
                                                        ? `${r.visit_date_dmy}`
                                                        : '-'
                                                    }
                                                </td>
                                                <td onClick={() => handleShow(r.id)}>
                                                    {r.visitperiod
                                                        ? `${r.visitperiod.period}`
                                                        : '-'
                                                    }
                                                </td>
                                                <td onClick={() => handleShow(r.id)}>
                                                    {r.initialstatus && r.initialstatus.translation.name || '-'}
                                                </td>
                                                <td onClick={() => handleShow(r.id)}>
                                                    {r.finalstatus && r.finalstatus.translation.name || '-'}
                                                </td>
                                                <td className="right" onClick={() => handleShow(r.id)}>
                                                    {r.reassign_price_formatted}
                                                    {r.currency ? r.currency.name : ''}
                                                </td>
                                                <td className="right" onClick={() => handleShow(r.id)}>
                                                    {r.parts_profit ?? '-'}
                                                    {r.currency ? r.currency.name : ''}
                                                </td>
                                                <td className="right" onClick={() => handleShow(r.id)}>
                                                    {renderPriceWithBreakdown(r, safeNum(r.partner_to_owner_price), safeNum(r.partner_to_owner_labour_price), safeNum(r.partner_to_owner_parts_price))}
                                                </td>
                                                <td className="right" onClick={() => handleShow(r.id)}>
                                                    {renderPriceWithBreakdown(r, safeNum(r.owner_to_partner_price), safeNum(r.owner_to_partner_labour_price), safeNum(r.owner_to_partner_parts_price))}
                                                </td>
                                                <td>
                                                    <span className="tooltip" style={{ whiteSpace: 'nowrap' }}>
                                                        {Number(r.sanctions_total_sum).toFixed(2)} {r.currency && r.currency.name}
                                                        {(r.sanctions || []).length > 0 &&
                                                            <div className="tooltip-body with-arrow">
                                                                <table>
                                                                    {(r.sanctions || []).map((oe, i) =>
                                                                        <tr>
                                                                            <td>
                                                                                {`${trans('labels.sanction')} #${i + 1}`}
                                                                            </td>
                                                                            <td style={{ width: '100px', textAlign: 'right' }}>
                                                                                <b style={{ whiteSpace: 'nowrap' }}>
                                                                                    {safeNum(oe.amount).toFixed(2)} {r.currency && r.currency.name}
                                                                                </b>
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                    <tr>
                                                                        <td colspan="2">
                                                                            <hr style={{
                                                                                margin: '5px 0',
                                                                            }} />
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>
                                                                            {trans('random.total')}:
                                                                        </td>
                                                                        <td style={{ width: '100px', textAlign: 'right' }}>
                                                                            <b style={{ whiteSpace: 'nowrap' }}>
                                                                                {safeNum(r.sanctions_total_sum).toFixed(2)} {r.currency && r.currency.name}
                                                                            </b>
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                            </div>
                                                        }
                                                    </span>
                                                </td>
                                                <td className="center" onClick={() => handleShow(r.id)}>
                                                    {safeNum(r.balance) === 0
                                                        ?
                                                        <span style={{ whiteSpace: 'nowrap' }}>
                                                            {(0).toFixed(2)} {r.currency && r.currency.name}
                                                        </span>
                                                        :
                                                        <label
                                                            className="btn"
                                                            style={{
                                                                whiteSpace: 'nowrap',
                                                                backgroundColor: safeNum(r.balance) > 0 ? '#57c17f' : '#fc676b',
                                                                color: '#fff',
                                                                padding: '5px 10px'
                                                            }}>
                                                            {safeNum(r.balance).toFixed(2)} {r.currency && r.currency.name}
                                                        </label>
                                                    }
                                                </td>
                                                <td className="center">
                                                    {r.partner_taxes_paid
                                                        ? <img src={checkIcon} height="12" alt="Paid" />
                                                        :
                                                        <button
                                                            className="button-small button-add button-simple"
                                                            style={{
                                                                margin: '0 auto',
                                                                pointerEvents: loadingPayment ? 'none' : 'auto',
                                                                opacity: !Number(r.reassign_price_formatted || 0) && !Number(r.parts_profit || 0) || loadingPayment ? 0.4 : 1
                                                            }}
                                                            onClick={e => {
                                                                e.stopPropagation()
                                                                handleMarkAsPaid([r.id])
                                                            }}
                                                            disabled={!Number(r.reassign_price_formatted || 0) && !Number(r.parts_profit || 0)}
                                                        >
                                                            {trans('buttons.pay')}
                                                        </button>

                                                    }
                                                </td>
                                                {!inModal ?
                                                    <td>
                                                        <Options
                                                            id={r.id}
                                                            data={r}
                                                            masterId={r.id}
                                                            handleRefresh={refreshData}
                                                        />
                                                    </td>
                                                    :
                                                    <>
                                                    </>
                                                }
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {!inModal ?
                            <>
                                <hr style={{ borderColor: '#fec724', borderWidth: '2px', margin: '15px 0 10px' }} />
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    color: '#595d7d',
                                    background: 'linear-gradient(to right, #fff, #fff, #d6dde5, #d6dde5)',
                                    borderRadius: '3px',
                                    padding: '10px',
                                    paddingLeft: 0
                                }}>
                                    <div className="actions">
                                        <select
                                            ref={selectRef}
                                            disabled={selected.length === 0}
                                        >
                                            <option></option>
                                            <option value="paid">{trans('buttons.markAsPaid')}</option>
                                            <option value="notpaid">{trans('buttons.markAsUnpaid')}</option>
                                            <option value="send">{trans('random.sendToContractor')}</option>
                                        </select>
                                        <button
                                            onClick={handleAction}
                                            disabled={selected.length === 0}
                                        >
                                            {trans('buttons.applyForSelected')}
                                        </button>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', textAlign: 'right' }}>
                                        <span>{trans('random.unpaidReservationsCount')} <strong>{state.totals?.unpaid_count ?? 0}</strong></span>
                                        <span>{trans('random.unpaidAmountTotal')} <strong>{state.totals?.unpaid_total_formatted ?? '0.00'} {state.totals?.currency?.name}</strong></span>
                                    </div>
                                </div>
                            </>
                            :
                            <>
                            </>
                        }
                    </>
            }

            {!state.loading
                ?
                <Pagination
                    pages={state.pages}
                    page={state.page}
                    handlePage={handlePage}
                />
                :
                ''
            }
        </>
    )
}

export default Reservations